import { Stack } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  nameBlock: ReactNode;
  roleBlock: ReactNode;
  permissionBlock: ReactNode;
  menuBlock: ReactNode;
  withBg: boolean;
};
export const SharedUserRow = ({
  nameBlock,
  roleBlock,
  permissionBlock,
  menuBlock,
  withBg,
}: Props) => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        gap: "24px",
        alignItems: "center",
        padding: "4px 16px",
        borderRadius: "6px",
        backgroundColor: withBg ? "#F7F7F7" : undefined,
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="flex-start"
        width="100%"
        flexShrink={1}
      >
        {nameBlock}
      </Stack>
      <Stack
        justifyContent="center"
        alignItems="flex-start"
        minWidth="120px"
        width="120px"
      >
        {roleBlock}
      </Stack>
      <Stack
        justifyContent="center"
        alignItems="center"
        minWidth="44px"
        width="44px"
      >
        {permissionBlock}
      </Stack>
      <Stack
        justifyContent="center"
        alignItems="center"
        minWidth="16px"
        width="16px"
      >
        {menuBlock}
      </Stack>
    </Stack>
  );
};
